import React from "react"
import { Dialog } from "primereact/dialog";
import moment from "moment";
import { useTranslation } from "react-i18next";


export const onGetReciept=({notification,reload,setRecieptModal})=>{
    if(!notification?.body) return null;
    const body=JSON.parse(notification?.body ?? "")
      //   const body = {
      //   id: 3,
      //   buyerNipt: "9999",
      //   buyerName: "General Customer",
      //   ublId: "47/2023/ch226pz644",
      //   iic: "F6F0F8E9D328ECCE9FE7DD8915A8C269",
      //   fic: "47fa4eae-267c-4e5e-a696-25d5cc3b4b93",
      //   issueDate: null,
      //   dueDate: null,
      //   transactionId: "401PPEB202672187",
      //   currency: "ALL",
      //   amount: 120.0,
      //   invoiceTotal: 120.0,
      //   paymentMethod: "BANKNOTE",
      //   recordDate: "2023-10-20T09:46:25.781+00:00",
      //   company: 159,
      //   source: "Bkt Smart",
      //   paymentType: "Bkt Pay Link",
      //   status: "RECEIVED"
      // };
    const { amount,currency="ALL",recordDate,transactionId,iic,fic,buyerName,ublId } =body ?? {}

    const data=[

      {label:"Buyer Name",value:buyerName},
      {label:"Ubl Id",value:ublId},
      {label:"Amount",value:amount+" "+currency},
      {label:"Date",value:recordDate?moment(recordDate).format("DD/MM/YYYY HH:MM"):""},
      {label:"Reference",value:transactionId},
      {label:"IIC",value:iic},
      {label:"FIC",value:fic},
    ]

      setRecieptModal({visible:true,data,body})
      reload();
}


export const RecieptModal=({recieptModal,setRecieptModal,body})=>{
    const { t } = useTranslation("translations");
    if(!recieptModal?.visible && recieptModal?.data?.length>0)return <></>
    return <Dialog
    header="Payment Notfication"
    visible={recieptModal.visible}
            onHide={() => setRecieptModal({visible:false,data:null})}
    style={{ width: "35vw" }}
    breakpoints={{ "960px": "75vw", "641px": "100vw" }}
  >
          <div className="modal-content">
            <div className="modal-header">
              <b style={{fontSize:15}}>
                {recieptModal?.body?.buyerName ?? ""} {t("bkt.hasPaid")} {recieptModal?.body?.amount ?? "0.00"} {recieptModal?.body?.currency }
              </b>
            </div>
        <div className="modal-body">
          {recieptModal?.data?.map((opt) => (
            <p key={opt.label} className="d-flex justify-content-between">
              <strong style={{width:"35%"}}>{opt.label}:</strong>
               <div className="d-flex" style={{width:"65%"}}>{opt.value}</div>
            </p>
          ))}
        </div>
      </div>

  </Dialog>
}